import { UserAssignmentsPermissions } from './userAssignments.permissions';
import { UserAssignmentsRoles } from './userAssignments.roles';

export const userAssignmentsMappings = {
  [UserAssignmentsPermissions.ASSIGN_USER]: [UserAssignmentsRoles.ASSIGNER],
};
